import { render, staticRenderFns } from "./ModalBody.vue?vue&type=template&id=5cd2f870&scoped=true"
import script from "./ModalBody.vue?vue&type=script&lang=js"
export * from "./ModalBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd2f870",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd2f870')) {
      api.createRecord('5cd2f870', component.options)
    } else {
      api.reload('5cd2f870', component.options)
    }
    module.hot.accept("./ModalBody.vue?vue&type=template&id=5cd2f870&scoped=true", function () {
      api.rerender('5cd2f870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/shared/components/modal/ModalBody.vue"
export default component.exports